namespace $ {

	export class $shm_hitalama_map_widget_entity_component extends $giper_baza_entity.with({

		Class_name: $giper_baza_atom_text,
		Extends: $giper_baza_atom_text,
		Type: $giper_baza_atom_text,
		Version: $giper_baza_atom_real,
		Methods: $giper_baza_atom_list,
		Css_selectors: $giper_baza_atom_list,

	}) {

		@ $mol_mem
		class_name( next?: string ) {
			return this.Class_name(next)?.val(next) ?? ''
		}

		@ $mol_mem
		extends_class( next?: string ) {
			return this.Extends(next)?.val(next) ?? ''
		}

		@ $mol_mem
		type( next?: string ) {
			return this.Type(next)?.val(next) ?? ''
		}

		@ $mol_mem
		version( next?: number ) {
			return this.Version(next)?.val(next) ?? 0
		}

		@ $mol_mem
		methods( next?: readonly any[] ) {
			return this.Methods(next as any)?.val(next as any) ?? []
		}

		@ $mol_mem
		css_selectors( next?: readonly any[] ) {
			return this.Css_selectors(next as any)?.val(next as any) ?? []
		}

		@ $mol_action
		data( next?: any ) {
			if( next !== undefined ) {
				this.class_name( next.class_name )
				this.extends_class( next.extends )
				this.type( next.type )
				this.version( next.version )
				this.methods( next.methods )
				this.css_selectors( next.css_selectors )
			}

			return {
				class_name: this.class_name(),
				extends: this.extends_class(),
				type: this.type(),
				version: this.version(),
				methods: this.methods(),
				css_selectors: this.css_selectors(),
			}
		}

	}

}
